
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-and-events/[slug]",
      function () {
        return require("private-next-pages/news-and-events/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-and-events/[slug]"])
      });
    }
  